(function(){
    'use strict';
    angular.module('Directives').directive('bbaMapOfficeLocation', bbaMapOfficeLocation);
    bbaMapOfficeLocation.$inject = ['MapLegendsConst', '$timeout'];

    function bbaMapOfficeLocation(MapLegendsConst, $timeout){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/office-location/bbaMapOfficeLocation.html',
            scope: {
                location: '='
            },
            link: bbaMapOfficeLocationLink
        }

        function bbaMapOfficeLocationLink(scope, element, attrs) {
            let googleMapInstance, geocoder;
            let warehouseMarkers = [];
            let debounceTimeout;

            scope.init = init;

            function init(){
                initMap();
                scope.$watch('location.location', (location) => {
                    addOfficeLocationMarker(location);
                }, true);
            }

            function initMap(){
                geocoder = new google.maps.Geocoder();
                googleMapInstance = new google.maps.Map(document.getElementById('map-office-location'), {
                    disableDefaultUI: true
                });
            }

            function addOfficeLocationMarker(location){
                if(location) {
                    if (!location.latitude || !location.longitude) {
                        const centerOfWorld = { lat: 40.1848, lng: 34.1999 };
                        googleMapInstance.panTo(centerOfWorld);
                        googleMapInstance.setZoom(0);
                        createOfficeWarehouseLocationMarker(centerOfWorld);
                        return; 
                    }

                    const lat = location.latitude; 
                    const lng = location.longitude;
                    const position = {lat: lat, lng: lng};
                    
                    googleMapInstance.panTo(position);
                    googleMapInstance.setZoom(14);
                    createOfficeWarehouseLocationMarker(position);
                }
            }

            function createOfficeWarehouseLocationMarker(position) {
                clearPreviousOfficeMarker();

                let image = MapLegendsConst.getIcons('locations').url;
                let officeLocationMarker = new google.maps.Marker({
                    position: position,
                    map: googleMapInstance,
                    icon: image,
                    draggable: true
                });

                google.maps.event.addListener(officeLocationMarker, 'dragend', onChangeMarker);
                
                warehouseMarkers.push(officeLocationMarker);
            }

            function onChangeMarker(event) {
                const latLng = event.latLng;
                const center = {lat: latLng.lat(), lng: latLng.lng()};
                googleMapInstance.panTo(center);

                geocoder.geocode({location: center}, (result) => {
                    if (!result) { return; }
                    const request = []; 
                    result[0].address_components.map((item) => {
                        item.types.map((t) => {
                            if ((t == 'street_number') || (t == 'route')) { 
                                request.push(item.short_name);
                            }
                        });
                    });
                    scope.location.addressLine1 = request.join(', ');
                });
            }

            function clearPreviousOfficeMarker(){
                warehouseMarkers.forEach( marker => {
                    marker.setMap(null);
                });
                warehouseMarkers = [];
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/office-location/bbaMapOfficeLocation.js